/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2023-12-28T10:48:56.715
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'report-reportbizrentcontractitempayment-'

export default 
{
path: '/report/reportbizrentcontractitempayment',
name: 'report-reportbizrentcontractitempayment',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}reportbizrentcontractitempayment-index',

meta:{
...meta,
title: '应收报表(业务)'
},

component: () => import('@/pages/report/reportbizrentcontractitempayment/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}reportbizrentcontractitempayment-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '应收报表编辑'
},

component: () => import('@/pages/report/reportbizrentcontractitempayment/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}reportbizrentcontractitempaymentdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '应收报表新增'
},

component: () => import('@/pages/report/reportbizrentcontractitempayment/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}reportbizrentcontractitempaymentView',
auth: [
'hidden'
],

meta:{
...meta,
title: '应收报表详情查看'
},

component: () => import('@/pages/report/reportbizrentcontractitempayment/detail-view') ,
},
]
};
